import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import classnames from "classnames";

import { AddressBlock } from "@/components/Account/Profile/ProfileAddressBook/components/AddressBlock/addressBlock.component";
import { Divider } from "@/components/General/Divider/divider.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    defaultPaymentAddress?: CloudCustomerAddress;
    defaultDeliveryAddress?: CloudCustomerAddress;
    updateDefaultBilling: (address: CloudCustomerAddress) => Promise<void>;
    updateDefaultDelivery: (address: CloudCustomerAddress) => Promise<void>;
    canDelete: boolean;
    updateAddress: (address: CloudCustomerAddress) => Promise<void>;
};

const DefaultAddresses = ({
    defaultPaymentAddress,
    defaultDeliveryAddress,
    updateDefaultBilling,
    updateDefaultDelivery,
    canDelete,
    updateAddress
}: Props) => {
    const { t } = useGranite();
    return (
        <>
            {(defaultPaymentAddress || defaultDeliveryAddress) && (
                <>
                    {(defaultPaymentAddress?.defaultDeliveryAddress ||
                        defaultDeliveryAddress?.defaultPaymentAddress) && (
                        <Row>
                            <Col>
                                <h3 className={classnames("mt-1")}>
                                    {t("address.title.paymentAndDelivery")}
                                </h3>
                                <Divider className={classnames("mb-3 mt-0")} />
                            </Col>
                        </Row>
                    )}
                    <Row>
                        {defaultPaymentAddress && (
                            <Col
                                xs={12}
                                md={6}
                            >
                                {!defaultPaymentAddress.defaultDeliveryAddress && (
                                    <>
                                        <h3 className={classnames("mt-1")}>
                                            {t("address.title.payment")}
                                        </h3>
                                        <Divider
                                            className={classnames("mb-3")}
                                        />
                                    </>
                                )}
                                <AddressBlock
                                    address={defaultPaymentAddress}
                                    updateDefaultDelivery={
                                        updateDefaultDelivery
                                    }
                                    updateDefaultBilling={updateDefaultBilling}
                                    canDelete={canDelete}
                                    addressType={AddressType.Payment}
                                    updateAddress={updateAddress}
                                />
                            </Col>
                        )}
                        <Col
                            xs={12}
                            md={6}
                        >
                            {defaultDeliveryAddress &&
                                !defaultDeliveryAddress.defaultPaymentAddress && (
                                    <>
                                        <h3 className={classnames("mt-1")}>
                                            {t("address.title.delivery")}
                                        </h3>
                                        <Divider
                                            className={classnames("mb-3")}
                                        />
                                        <AddressBlock
                                            address={defaultDeliveryAddress}
                                            updateDefaultDelivery={
                                                updateDefaultDelivery
                                            }
                                            updateDefaultBilling={
                                                updateDefaultBilling
                                            }
                                            canDelete={canDelete}
                                            addressType={AddressType.Delivery}
                                            updateAddress={updateAddress}
                                        />
                                    </>
                                )}
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};

export default DefaultAddresses;
